<div class="dialog">
  <h4 mat-dialog-title>{{ data.title }}</h4>

  <div mat-dialog-content>
    <mat-form-field *ngFor="let field of data.fields" appearance="fill" class="full-width" [class.required-field]="field.required">
      <mat-label>{{ field.label }}</mat-label>
      <input
        *ngIf="field.type !== 'select'"
        matInput
        [(ngModel)]="formValues[field.key]"
        [placeholder]="field.placeholder || ('common_placeholder_enter_value' | translate)"
        [type]="field.type || 'text'"
        [attr.maxlength]="field.maxLength"
        [required]="field.required || false"
        [attr.aria-required]="field.required || false" />
      <mat-select
        *ngIf="field.type === 'select'"
        [(ngModel)]="formValues[field.key]"
        [placeholder]="field.placeholder || ('common_placeholder_enter_value' | translate)"
        [required]="field.required || false"
        [attr.aria-required]="field.required || false">
        <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
      <mat-hint align="end" *ngIf="field.maxLength">{{ formValues[field.key]?.length || 0 }} / {{ field.maxLength }}</mat-hint>
      <mat-error *ngIf="field.required && (!formValues[field.key] || formValues[field.key].trim() === '')">{{ 'common_error_field_required' | translate }}</mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onClose()">{{ 'common_btn_close' | translate }}</button>
    <button mat-button (click)="onValidate()" color="accent" [disabled]="!isFormValid()">{{ 'common_btn_validate' | translate }}</button>
  </div>
</div>
